module.exports = __webpack_public_path__ + "img/03.b2a0bacb.jpg";